module.exports = __webpack_public_path__ + "img/tab3.f7e6aefa.png";